<template>
  <ContainerDefault>
    <div class="flex flex-col min-h-screen">

      <!-- Main Content (Split into Left and Right Sides) -->
      <div class="flex-grow flex md:pb-12 xxxl:pb-4">

        <!-- Left Side -->
        <div :class="[isShortScreen ? 'items-center translate-up ' : 'items-center translate-default', 'hidden lg:flex lg:min-h-[1000px] lg:w-1/2 justify-end md:pt-[10px] md:pr-[43px]']">
          <div class="smooth-transition max-w-[558px] text-left">
          <img src="@/assets/images/logo/m4c-logo-dark.svg" alt="Media4Change" class="w-[166px] h-[66px] mt-[2px] ml-[1px] mb-6 mx-auto" />
            <h2 class="text-4xl leading-12 font-bold mt-5 mb-0 ml-[1px] pt-[1px]" v-html="addLineBreaks(t('intro.title'))"></h2>
            <p class="text-xl leading-8 mt-4 pr-3">
              {{ t('intro.text') }}
            </p>
            <div class="mt-[34px] pl-[5px] flex justify-center">
              <img src="@/assets/images/elements/chat-dark-v2.svg" alt="Media4Change" class="max-w-[452px]" />
            </div>
          </div>
        </div>

        <!-- Right Side -->
        <div class="flex w-full lg:w-1/2 items-center justify-center lg:justify-start pt-6 pl-4 pr-4 pb-4 lg:pt-8 lg:pl-[114px] smooth-transition">
          <div class="max-w-[486px] w-full ">
            <slot></slot>
          </div>
        </div>

      </div>

      <!-- Footer Component -->
      <AppFooter />
    </div>
  </ContainerDefault>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const { t } = useI18n();
const isShortScreen = ref(false);

// Function to add <br> after every 4 words
function addLineBreaks(text: string, wordsPerLine: number = 4): string {
  const words = text.split(' '); // Split the text by spaces
  let result = '';

  // Loop through the words and add <br> after every 'wordsPerLine' words
  for (let i = 0; i < words.length; i++) {
    result += words[i] + ' ';
    if ((i + 1) % wordsPerLine === 0 && i !== words.length - 1) {
      result += '<br>';
    }
  }

  return result.trim();
}

// Function to check screen height and update the state
function updateScreenHeight() {
  isShortScreen.value = window.innerHeight < 800;
}

onMounted(() => {
  updateScreenHeight();
  window.addEventListener('resize', updateScreenHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScreenHeight);
});
</script>

<style scoped>
/* Ensure that the flex layout for the content grows and doesn't overlap the footer */
.flex-grow {
  flex-grow: 1;
}

/* Add a smooth transition when position or other properties change */
.smooth-transition {
  transition: transform 0.8s ease-in-out; /* Use transform for smoother performance */
}

/* Classes to control element's transform property for smooth transitions */
.translate-up {
  transform: translateY(-20px); /* Move element up */
}

.translate-default {
  transform: translateY(0); /* Default position */
}
</style>
